module.exports = __webpack_public_path__ + "static/media/mSlider4.027dded5.png";